import { render } from "./NuovoRapportino.vue?vue&type=template&id=87277784&scoped=true"
import script from "./NuovoRapportino.vue?vue&type=script&lang=js"
export * from "./NuovoRapportino.vue?vue&type=script&lang=js"

import "./NuovoRapportino.vue?vue&type=style&index=0&id=87277784&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_puma/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87277784"]])

export default __exports__